import {
  StackItem,
  UtilityText,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { TextFormField } from 'components/form-fields/text-form-field/text-form-field.component';
import { FormState } from 'components/onboarding-account-setup/types/onboarding-account-setup-types';
import { formatAuMobile } from 'components/onboarding-account-setup/utils/onboarding-account-setup.format';

export interface MobileNumberInputProps {
  value: FormState['mobileNumber'];
  onChange: (value: string) => void;
  error: FormState['mobileNumberError'];
  errorMessage?: string;
}

const renderParagraph = (chunk: React.ReactNode) => (
  <ParagraphText css={{ color: '$onSurfaceTextSubdued' }}>
    {chunk}
  </ParagraphText>
);

export const MobileNumberInput = ({
  value,
  onChange,
  error,
  errorMessage,
}: MobileNumberInputProps) => {
  const { formatMessage } = useIntl();
  const localisedError = error ? formatMessage({ id: error }) : null;
  const displayedError = errorMessage || localisedError;
  return (
    <StackItem css={{ gap: '$oneAndHalf' }}>
      <UtilityText emphasis="subtle">
        {formatMessage(
          { id: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_HELPER' },
          {
            p: renderParagraph,
          },
        )}
      </UtilityText>
      <TextFormField
        id="mobile-number"
        name="mobile-number"
        label={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_LABEL',
        })}
        value={formatAuMobile(value)}
        onChange={(e) => onChange(formatAuMobile(e.target.value))}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        placeholder={formatMessage({
          id: 'STR_ONBOARDING_ACCOUNT_SETUP_MOBILE_PLACEHOLDER',
        })}
        error={displayedError}
        css={{
          maxWidth: '75%',
          '@mobile': { maxWidth: 'unset' },
        }}
        required
      />
    </StackItem>
  );
};
